import React from 'react';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';

import authenticationSelector from './authenticationSelector';
import Login from './Login';
import InitLogin from './InitLogin';
import LoadingIndicator from '../common/components/LoadingIndicator';

function Authentication() {
  const isInitialized = useSelector(authenticationSelector.isInitialized);
  const isLoading = useSelector(authenticationSelector.isLoading);

  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        margin: ' 64px 24px 32px 24px',
        padding: '24px 32px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      {isLoading ? <LoadingIndicator /> : isInitialized ? <Login /> : <InitLogin />}
    </Paper>
  );
}

export default Authentication;
